import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import RichText from "@/components/RichText";
import { Reveal, PrimaryButton } from "@/components/primitives";
import Snippet from "@/components/Snippet";
import { useSite } from "@/context/SiteContext";
import { LIB } from "@/data/content";

export default function Testimonials() {
  const { page } = useSite();
  const p = page("testimonials");

  return (
    <div>
      <PageHero {...p.hero} image={LIB.coastDawnRocks} imageAlt="A tranquil seascape at dawn" />

      <section className="py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Reveal><RichText html={p.body_html} className="testimonials-rich" /></Reveal>

          <Reveal delay={0.1}>
            <div className="mt-14 text-center rounded-3xl border border-brand-line bg-brand-lavender-soft/50 p-10">
              <h3 className="font-heading text-2xl text-brand-ink mb-3"><Snippet k="testimonials.cta_heading" fallback="Ready to experience it yourself?" /></h3>
              <p className="font-body text-brand-slate mb-6"><Snippet k="testimonials.cta_text" fallback="Book a session or reach out with any questions." /></p>
              <PrimaryButton as={Link} to="/book" data-testid="testimonials-book-btn">
                <Snippet k="testimonials.cta_btn" fallback="Book a session" /> <ArrowRight size={18} strokeWidth={1.5} />
              </PrimaryButton>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
